import { React } from 'react';

import { Card, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Self-serve signup is GONE (fall model §3g, 2026-07-15): portal accounts are
// enrollment-gated. A placed family receives an emailed claim link
// (/portal/claim) that creates their account bound to their student records —
// there is nothing to sign up for without one. This page stays at
// /portal/signup as the explainer for anyone who lands here expecting a form.
export default function PortalSignup() {
	return (
		<>
			<Container className='justify-content-center py-5' fluid>
				<Card
					className='mx-auto bg-transparent border-1 p-2 shadow-sm'
					style={{ maxWidth: '450px' }}>
					<Card.Header className='bg-transparent border-0 text-center'>
						<h2 className='mb-0' style={{ color: '#384971' }}>
							Portal Accounts Are by Invite
						</h2>
					</Card.Header>
					<Card.Body>
						<p>
							Family portal accounts are created through a
							personal invitation once your family is placed for
							lessons — that keeps your schedule and your
							students' information private to you.
						</p>
						<p className='mb-2'>
							<strong>Already enrolled?</strong> Look for a{' '}
							<em>"Set up your account"</em> email from Color
							Your Voice and follow its link. Can't find it?
							Reach out and we'll send a fresh one.
						</p>
						<p className='mb-0'>
							<strong>New to Color Your Voice?</strong> Reach
							out and we'll take it from there.
						</p>
					</Card.Body>
					<Card.Footer className='bg-transparent border-0'>
						<div className='d-grid gap-2 mb-3'>
							<Button
								as={Link}
								to='/contact'
								variant='primary'
								className='shadow-none'>
								Contact Us
							</Button>
						</div>
						<p className='text-center mb-0'>
							Already have a portal account?{' '}
							<Link to='/portal/login'>Log In</Link>
						</p>
					</Card.Footer>
				</Card>
			</Container>
		</>
	);
}
